module.exports = __webpack_public_path__ + "img/stock5.64d8af28.png";